import React from "react";

import Tridi from "react-tridi-wrapper";

import icon from "./../../../UI/general/BikeMenu/personaliza.svg";
import back from "./../../../UI/general/back.svg";
import { routesData } from "../../../data/routes.data";

class BikeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { updatedSet: "", zoom: 80 };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentColor !== this.props.currentColor) {
      this.setState(
        {
          updatedSet:
            routesData()[0][
              this.props.selectedBike.Nombre + " " + this.props.currentColor
            ],
        },
        () => {
          console.log(this.state.updatedSet);
        }
      );
    }
  }

  createColorStructure = () => {
    return (
      <div className="color-container">
        {this.props.currentColorsArray.map((color, index) => (
          <div className="color-individual-container" key={index}>
            <div
              className={
                this.props.currentColorIndex === index
                  ? "color-ball selected-color"
                  : "color-ball"
              }
              style={{
                background:
                  "linear-gradient(125deg," +
                  color.hexa +
                  " 40%," +
                  color.hexaAlt +
                  ")",
              }}
              onClick={() => {
                this.props.handleChangeColors(index);
              }}
            />
          </div>
        ))}
      </div>
    );
  };

  handleZoom = (payload) => {
    this.setState(
      {
        zoom:
          this.state.zoom + payload > 100
            ? 100
            : this.state.zoom + payload < 80
            ? 80
            : this.state.zoom + payload,
      },
      () => {
        console.log(this.state.zoom);
        var container =
          document.getElementsByClassName("tridi-viewer-image")[0];
        container.style.minHeight = String(this.state.zoom) + "%";
        container.style.maxHeight = String(this.state.zoom) + "%";
      }
    );
  };

  render() {
    return (
      <div
        className={
          this.props.isSpinOpened
            ? "bike-view-main fade-in"
            : "bike-view-main fade-out"
        }
      >
        <div
          className="bike-view-back"
          onClick={() => {
            this.props.handleCloseSpin();
          }}
        >
          <img src={back} />
          <div className="">Volver al Showroom</div>
        </div>
        {this.props.isSpinOpened ? (
          <Tridi
            element={".tridi-basic"}
            dragInterval={1}
            touchDragInterval={2}
            location={this.state.updatedSet}
            format="webp"
            count="60"
            zoom="3"
            showControlBar={true}
          />
        ) : null}
        <div className="bike-view-options">
          <div className="bike-view-icon-container">
            <img src={icon} />
            <div>Color</div>
          </div>
          {this.props.currentColorsArray.length > 0
            ? this.createColorStructure()
            : null}
          <div className="bike-view-zoom">
            <div
              className="plus"
              onClick={() => {
                this.handleZoom(+1);
              }}
            >
              +
            </div>
            <div
              className="minus"
              onClick={() => {
                this.handleZoom(-1);
              }}
            >
              -
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default BikeView;
